import api from './api';

/**
 * Notification Inbox Service - persistent in-app notifications.
 * (Transient toasts live in notificationService.js.)
 * Backend contract documented in BACKEND_SPECS.md ("Notification inbox").
 */
const notificationInboxService = {
  /**
   * Get notifications for the current user (newest first).
   * @param {Object} params - { page, limit, unread }
   * @returns {Promise} { items: [{ _id, type, title, body, link, read, createdAt }], total, unread }
   */
  getAll: async (params = {}) => {
    const response = await api.get('api/user/notifications', { params });
    return response.data;
  },

  /**
   * Mark one notification as read.
   * @param {string} id
   */
  markRead: async (id) => {
    const response = await api.put(`api/user/notifications/${id}/read`);
    return response.data;
  },

  /**
   * Mark all notifications as read.
   */
  markAllRead: async () => {
    const response = await api.put('api/user/notifications/read-all');
    return response.data;
  },

  /**
   * Get notification preferences (weekly recap, milestones, royalties).
   * @returns {Promise} { weeklyRecap: bool, milestones: bool, royaltyReports: bool }
   */
  getPreferences: async () => {
    const response = await api.get('api/user/notifications/preferences');
    return response.data;
  },

  /**
   * Save notification preferences.
   * @param {Object} preferences
   */
  savePreferences: async (preferences) => {
    const response = await api.put('api/user/notifications/preferences', preferences);
    return response.data;
  },
};

export default notificationInboxService;
